const CirclePlusSvg = (): JSX.Element => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
			<path
				d='M12.9836 11.0164V7H11.0164V11.0164H7V12.9836H11.0164V17H12.9836V12.9836H17V11.0164H12.9836Z'
				fill='#F5F5F5'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12 3.96721C7.56361 3.96721 3.96721 7.56361 3.96721 12C3.96721 16.4364 7.56361 20.0328 12 20.0328C16.4364 20.0328 20.0328 16.4364 20.0328 12C20.0328 7.56361 16.4364 3.96721 12 3.96721ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z'
				fill='#F5F5F5'
			/>
		</svg>
	)
}

export default CirclePlusSvg
